import { inject, Injectable } from '@angular/core';
import { BaseRequestService, CacheService, IsFollowing, ResponseList } from '@outlaw/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FollowersRequestParams, FollowerUser, ShortFollowedUser, ShortFollowedUserResponse } from '../../interfaces';
import { CommunityConfigService } from '../util';

@Injectable({ providedIn: 'root' })
export class FollowerService {
  cacheService = inject(CacheService);
  followersUrl = inject(CommunityConfigService).internalApi.followersUrl;
  postUrl = inject(CommunityConfigService).internalApi.postUrl;

  baseRequestService = inject(BaseRequestService);
  http = inject(HttpClient);

  followUser(userUUID: string): Observable<any> {
    return this.http.post(this.baseRequestService.prepareUrl([this.followersUrl, 'follow_user', userUUID]), null);
  }

  unfollowUser(userUUID: string): Observable<any> {
    return this.http.delete(this.baseRequestService.prepareUrl([this.followersUrl, 'unfollow_user', userUUID]));
  }

  getFollowers({ userUUID, limit, cursorId }: FollowersRequestParams): Observable<ResponseList<FollowerUser>> {
    let params = new HttpParams();
    params = params.append('user_uuid', userUUID);
    params = params.append('limit', limit.toString());
    if (cursorId) {
      params = params.append('cursor', cursorId);
    }

    return this.http.get<ResponseList<FollowerUser>>(this.baseRequestService.prepareUrl([this.followersUrl]), {
      params,
    });
  }

  listIntersections(userUUID: string): Observable<ShortFollowedUser[]> {
    let params = new HttpParams();
    params = params.append('user_uuid', userUUID);
    return this.http.get<ShortFollowedUser[]>(
      this.baseRequestService.prepareUrl([this.followersUrl, 'list_intersections']),
      { params }
    );
  }

  listIntersectionsBulk(userUUIDs: string[]): Observable<ShortFollowedUserResponse> {
    let params = new HttpParams();
    params = params.append('user_uuids', userUUIDs.join(','));
    return this.http.get<ShortFollowedUserResponse>(
      this.baseRequestService.prepareUrl([this.followersUrl, 'list_intersections_bulk']),
      { params }
    );
  }

  isFollowing(userId: string): Observable<IsFollowing> {
    return this.http.get<IsFollowing>(this.baseRequestService.prepareUrl([this.followersUrl, 'is_following', userId]));
  }
}
